import "./App.css";
import { Routes, Route } from "react-router-dom";
import Home from "../src/components/Home";
import Footer from "./components/Footer";
import Header from "./components/Header";
import AccessControl from "./components/solutions/detailAccessControl/home";
import PrivacyPolicyPage from "./components/privacyPolicy";

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/accesscontrol" element={<AccessControl />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
